import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { View } from "lucide-react";
import Permiso from "../../router/Permiso";
import { useNavigate } from "react-router-dom";
import { ticketService } from "../../services/TicketService";

const ListadoSupport = ({ token, debeRecargar, onRecargaCompleta }) => {
  const navigate = useNavigate();

  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [estados, setEstados] = useState([]);
  const [tipos, setTipos] = useState([]);
  const [filtroEstado, setFiltroEstado] = useState("");
  const [filtroTipo, setFiltroTipo] = useState("");
  const [buscarNombre, setBuscarNombre] = useState("");

  useEffect(() => {
    fetchTickets();
  }, [currentPage, fechaInicio, fechaFin, filtroEstado, filtroTipo, buscarNombre]);

  useEffect(() => {
    cargarEstados();
    cargarTipos();
  }, []);

  const fetchTickets = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await ticketService.fetchTicket({
        token,
        pagina: currentPage,
        pageSize: 20,
        desde: fechaInicio,
        hasta: fechaFin,
        estado: filtroEstado,
        tipo: filtroTipo,
        nombre: buscarNombre
      });

      setTickets(res.tickets);
      setTotalPages(res.totalPaginas);
      setTotalRegistros(res.totalRegistros);
    } catch (err) {
      console.log("Error al cargar las solicitudes",err);
      setError("Error al cargar las solicitudes");
    } finally {
      setLoading(false);
    }
  };

  const handleConsultarTicket = async (ticket) => {
    navigate(`/admin/soporte/consultar/${ticket.id}`);
  };

  const cargarEstados = async () => {
    try {
      const response = await ticketService.getEstadoTicket(token);
      setEstados(response);
    } catch (error) {
      console.error("Error al cargar perfiles:", error);
    }
  };

  const cargarTipos = async () => {
    try {
      const response = await ticketService.getTiposSolicitud(token);
      setTipos(response);
    } catch (error) {
      console.error("Error al cargar perfiles:", error);
    }
  };

  const exportarExcel = async () => {
    try {
      const filtros = {
        desde: fechaInicio,
        hasta: fechaFin,
        estado: filtroEstado,
        tipo: filtroTipo,
        nombre: buscarNombre
      };

      const blob = await ticketService.exportarSolicitudesExcel(token, filtros);

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Tickets.xlsx";
      document.body.appendChild(link);
      link.click();
      link.remove();
       URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error al exportar Excel:", error);
    }
  };

  useEffect(() => {
    if (debeRecargar) {
      fetchTickets().then(() => {
        onRecargaCompleta();
      });
    }
  }, [debeRecargar]);

  return (
    <div className="productos-admin-container">
      <div className="ventas-table-header">
        <h2 className="ventas-table-title">Listado de solicitudes</h2>
        <div className="productos-actions">
          <Permiso permiso="export_chat">
            <button onClick={exportarExcel} className="btn-exportar">
              Exportar a Excel
            </button>
          </Permiso>
        </div>
      </div>

      {/* Filtro de búsqueda */}
      <div className="usuarios-filtros">
        <div className="filtro-item">
          <label htmlFor="buscar-usuario">Buscar por Usuario:</label>
          <input
            type="text"
            value={buscarNombre}
            onChange={(e) => setBuscarNombre(e.target.value)}
            placeholder="Nombre, apellido o nombre completo"
          />
        </div>
        <div className="filtro-item">
          <label htmlFor="fecha-inicio">Fecha Inicio:</label>
          <input
            type="date"
            value={fechaInicio}
            onChange={(e) => setFechaInicio(e.target.value)}
          />
        </div>
        <div className="filtro-item">
          <label htmlFor="fecha-fin">Fecha Fin:</label>
          <input
            type="date"
            value={fechaFin}
            onChange={(e) => setFechaFin(e.target.value)}
          />
        </div>
        <div className="filtro-grupo">
          <label htmlFor="tipo-solicitud">Tipos de Solicitud:</label>
          <select
            id="filtroTipo"
            value={filtroTipo}
            onChange={(e) => setFiltroTipo(e.target.value)}
            className="filtro-select"
          >
            <option value="">Todos los tipos</option>
            {tipos.map((tipo) => (
              <option key={tipo.id} value={tipo.id}>
                {tipo.descripcion}
              </option>
            ))}
          </select>
        </div>
        <div className="filtro-grupo">
          <label htmlFor="estado">ESTADO:</label>
          <select
            id="filtroEstado"
            value={filtroEstado}
            onChange={(e) => setFiltroEstado(e.target.value)}
            className="filtro-select"
          >
            <option value="">Todos los estados</option>
            {estados.map((estado) => (
              <option key={estado.id} value={estado.id}>
                {estado.descripcion}
              </option>
            ))}
          </select>
        </div>
        <div className="filtro-grupo">
          <button
            onClick={() => {
              setFechaInicio("");
              setFechaFin("");
              setBuscarNombre("");
              setFiltroEstado("");
              setFiltroTipo("");
            }}
            className="btn-limpiar-filtros"
          >
            Limpiar Filtros
          </button>
        </div>
      </div>

      {error && <div className="error-message">{error}</div>}

      {loading ? (
        <div className="loading">
          <div className="loading-spinner"></div>
          <p>Cargando solicitudes...</p>
        </div>
      ) : (
        <>
          <div className="productos-table-wrapper">
            <table className="productos-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Solicitado Por</th>
                  <th>Tipo de Solicitud</th>
                  <th>Atendido Por</th>
                  <th>Estado</th>
                  <th>Fecha</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {tickets.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="no-data">
                      <div className="no-data-content">
                        <p>No hay solicitudes registradas</p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  tickets.map((ticket) => (
                    <tr key={ticket.id} className="producto-row">
                      <td className="producto-id">#{ticket.id}</td>
                      <td className="producto-descripcion">
                        {ticket.usuario_nombre}  {ticket.usuario_apellido}
                      </td>
                      <td className="">{ticket.descripcion_solicitud || ""}</td>
                      <td className="">
                        {ticket.asignado_nombre}  {ticket.asignado_apellido}
                      </td>
                      <td className="">

                        {ticket.estado_descripcion}

                      </td>
                      <td>
                        {new Date(ticket.fecha_creacion).toLocaleString('es-PE', {
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit',
                          second: '2-digit',
                          hour12: true
                        })}
                      </td>
                      <td className="producto-acciones">
                        <Permiso permiso="view_soporte_detail">
                          <button
                            style={{
                              background: "none",
                              border: "none",
                              padding: 0,
                              cursor: "pointer",
                              outline: "inherit",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "inherit",
                            }}
                            onClick={() => handleConsultarTicket(ticket)}
                          >
                            <View size={20} />
                          </button>
                        </Permiso>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          <span style={{ marginLeft: "12px", fontSize: "14px", color: "#555" }}>
            {" "}
            Total de registros: {totalRegistros}{" "}
          </span>
          <div className="pagination">
            <button
              onClick={() => setCurrentPage(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Anterior
            </button>
            <span>
              Página {currentPage} de {totalPages}
            </span>

            <button
              onClick={() => setCurrentPage(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Siguiente
            </button>
          </div>
        </>
      )}
    </div>
  );
};

ListadoSupport.propTypes = {
  token: PropTypes.string.isRequired,
  debeRecargar: PropTypes.bool,
  onRecargaCompleta: PropTypes.func,
};

export default ListadoSupport;
